<template>
  <div>
        <b-modal :id="idModal" hide-footer centered @hide="handleOffModal" size="lg" >
            <div class="position-rel">
                <!-- {{ getDataModalNoti }} -->
                <button
                    @click="exitModal"
                    type="button"
                    class="btn-close secondary_text_color font-size-16 font-sanpro-semibold four-color border-0 bg-transparent"
                    >
                    <img src="@/assets/img/icon-close.png" class="icon-close" alt />
                </button>
                <h3 class="font-sanpro-semibold primary-color-txt font-size-16">{{getDataModalNoti.title}}</h3>
                <div class="css-message">
                    <p class="font-sanpro primary-color-txt font-size-16 margin-0" v-html="getDataModalNoti.message">
                </p>
                </div>
            </div>
        </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import { ID_MODAL_NOTIFY } from '@/store/common/constants'
import { fetchNotification } from "@/store/common/api";
export default {
    name: "modalNotify",
    data(){
        return{
            idModal: ID_MODAL_NOTIFY,
            paramsNotify: {
                "direction": "",
                "keyword": "",
                "pageIndex": 1,
                "pageSize": 10,
                "sort": ""
            }
        }
    },

    watch: {
        isShowModalNotify(newVal){
            if(newVal){
                // console.log('newewe', newVal);
                fetchNotification(this.paramsNotify)
                // .then(res => {
                //     console.log('res', res);
                // })
            }
        }  
    },
    computed:{
        ...mapState("common", [ "isShowModalNotify", "getDataModalNoti"]),
    },
    mounted(){
        this.acToggleModalShowNotify(false)
    },
    methods:{
        ...mapActions(`common`, [
            "setLoading",
            "acToggleModalShowNotify"
        ]),
        handleOffModal(){
            this.acToggleModalShowNotify(false)
            // console.log('modal notify', this.isShowModalNotify);
        },
        exitModal(){
            this.$bvModal.hide(ID_MODAL_NOTIFY)
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-close{
    position: absolute;
    right: -8px;
    top: -10px;
    width: 25px;
}

</style>